const EventEmitter = require('eventemitter3');

const StandardStrike = require('../StandardStrike');
const BattleCalc = require('../../BattleCalc');
const BattleConfig = require('../../../constants/BattleConfig');
const CCHandler = require('../../CCHandler');
const SlowedCondition = require('../../conditions/SlowedCondition');
const { logError } = require('../../logger');

const LegShot = function (battleState) {
  this.handle = 'leg_shot';
  this.physical = true;
  this.bow = true;
  this.ranged = true;
  this.harm = true;

  this.standardStrike = new StandardStrike(this, battleState);

  this.eventEmitter = new EventEmitter();

  this.isLegal = function (actor, victim) {
    return (
      victim.unit &&
      actor.equipment.off_hand &&
      actor.equipment.off_hand.type === 'bow'
    );
  };

  this.execute = function (actor, victim) {
    if (!actor || !actor.inPlay || !victim || (victim.unit && !victim.inPlay)) {
      return { success: false };
    }

    const ability = BattleCalc.getEquippedAbility(actor, 'leg_shot');

    setTimeout(() => {
      try {
        if (
          !actor ||
          !actor.inPlay ||
          !victim ||
          (victim.unit && !victim.inPlay)
        ) {
          return;
        }

        const result = this.standardStrike.execute(
          actor,
          victim,
          ability.damage,
          true
        );
        result.abilityHandle = this.handle;
        result.actorId = actor.uid;
        result.victimId = victim.uid;
        result.allPieces = battleState.allPieces;

        if (
          result.success &&
          !victim.dead &&
          !CCHandler.checkForResistSlow(victim, battleState)
        ) {
          var slowed = new SlowedCondition(
            actor,
            victim,
            battleState,
            ability.duration
          );
          slowed.instigatorId = actor.uid;
          slowed.ownerId = victim.uid;
          battleState.onUnitCondition(slowed);
          result.slowedCondition = slowed;
        }

        this.eventEmitter.emit('result', result);
      } catch (err) {
        logError(err, {
          module: 'LegShot',
          func: 'execute',
          actor,
          victim,
        });
      }
    }, BattleCalc.projectileTime(BattleConfig.ARROW_SPEED, actor, victim));
  };
};
module.exports = LegShot;
